/* eslint-disable @typescript-eslint/no-explicit-any */
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
export interface PortItem {
	id: string | null;
	portName: string;
	subid: string;
	internetEnterpriseVlan: number;
	internetEnterpriseMbps: number;
	internetEnterpriseSubsId: string;
	internetEnterpriseRouting: string;
	internetEnterpriseTerms: string;
	hardwareStatus: number;
	name: string;
	vlan: number;
	cloud: string;
	provider: string;
	account: string;
	autoRenew: string;
	automaticVlan: string;
	type: string;
	fwintFwaasSubsId?: string;
	vlanDisplay?: string;
  }
/**
 * 6 columnas:
 *   Id | Name | Capacity | VLAN | ID | Status
 */
export const portsDetailsColumns = (
): GenericTableColumn<PortItem>[] => [
			{
				header: "Connection Id",
				accessor: "internetEnterpriseSubsId",
			},
			{
				header: "Type",
				accessor: "type",
			},
			{
				header: "Terms",
				accessor: "internetEnterpriseTerms",
			},
			{
				header: "Mbps",
				accessor: "internetEnterpriseMbps",
			},
			{
				header: "Cloud",
				accessor: "cloud",
			},
			{
				header: "Provider",
				accessor: "provider",
			},
			{
				header: "Account",
				accessor: "account",
			},
			{
				header: "VLAN",
				accessor: "vlan",
				renderCell: (row) => row.vlanDisplay ?? (Number.isFinite(row.vlan) ? String(row.vlan) : "-"),
			},
			{
				header: "Routing",
				accessor: "internetEnterpriseRouting",
			},
			{
				header: "Automatic VLAN",
				accessor: "automaticVlan",
			}
	];

/**
 * Function to filter table data based on search term and column
 */
export const getFilteredData = (data: PortItem[], searchTerm: string, searchColumn: string): PortItem[] => {
	const term = searchTerm.toLowerCase();
	if (!term) return data;
	const includes = (val: any) => val?.toString().toLowerCase().includes(term);

	return data.filter((row) => {
		switch (searchColumn) {
			case "Name":
					return includes(row.name);
			case "VLAN":
					return includes(row.vlan);
			case "ID":
					return includes(row.id);
			case "All":
			default:
				return (
					includes(row.name) ||
					includes(row.vlan) ||
					includes(row.id)
				);
			}
	});
};

